import { FormInstance } from "antd";
import FormWrapper from "../../../../../components/UI/FormWrapper/FormWrapper";
import { useState } from "react";
import MemberDetailsForm from "./MemberDetailsForm";
import ClaimDetailsForm from "./ClaimDetailsForm";
import Checkbox from "antd/lib/checkbox/Checkbox";
import { DynamicClaimsApiFields } from "./ClaimForm";

interface Props {
  onPrev: VoidFunction;
  onSave: VoidFunction;
  form: FormInstance;
  dynamicFields: DynamicClaimsApiFields[];
  ghiDetails: any;
  loading: boolean;
}

const ClaimFormReview: React.FC<Props> = ({ onPrev, onSave, form, dynamicFields, ghiDetails, loading }) => {
  const [disabled, setDisabled] = useState<boolean>(true);

  return <FormWrapper primaryButton={{
    active: true,
    loading: loading,
    disabled: disabled,
    title: 'Save',
    onClick: onSave
  }} secondaryButton={{
    active: true,
    loading: false,
    disabled: false,
    title: 'Back',
    onClick: onPrev
  }}>
    <div className="card-title mb-32">Review and confirm the following details before submitting</div>
    <div>
      <MemberDetailsForm form={form} readonly ghiDetails={ghiDetails} />
    </div>
    <div className="mt-32">
      <ClaimDetailsForm form={form} dynamicFields={dynamicFields} readonly />
    </div>
    <div className="mt-32">
      <div className="card-title">Declaration:</div>
      <Checkbox onChange={(e)=>setDisabled(!e?.target?.checked)}>I have re-checked the details and I want to raise the reimbursement claim</Checkbox>
    </div>
  </FormWrapper>
};

export default ClaimFormReview;
